import React, {useRef, useReducer, useEffect} from 'react';
import Header from './Header'
import Footer from './Footer'
import Content from './Content'

import {appContext} from '../contexts'
import {appReducer} from '../fn'

import '../styles/App.scss';



function App() {
  const headerRef = useRef(null)
  const mediaRef = useRef(null)
  const projectsRef = useRef(null)
  const contactRef = useRef(null)
  const aboutRef = useRef(null)

  const [state, dispatch] = useReducer(appReducer, {mode: null})

  const val = {
    ...state,
    headerRef : headerRef,
    dispatch: action => dispatch(action),
    mediaRef: mediaRef,
    projectsRef: projectsRef,
    contactRef: contactRef,
    aboutRef: aboutRef
  }

  useEffect(()=>{
    fetch('/api').then(res => res.json()).then(res => console.log(res))
  }, [])

  return (
    <appContext.Provider value={val}>
      <div className="App">
        <Header />
        <Content />
        <Footer />
      </div>
    </appContext.Provider>
  );
}

export default App;
